import { useRef, useState } from "react";
import { PenLine } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Modal, modalBtnPrimary, modalBtnSecondary } from "../Modal";
import { SignaturePad } from "../SignaturePad";

const inp = "w-full min-h-[48px] px-3 py-2 border border-slate-300 text-base rounded-sm bg-white";

export function ReturnModal({ tool, onClose, onDone }) {
    const [condition, setCondition] = useState("");
    const [busy, setBusy] = useState(false);
    const sigRef = useRef();
    const craftsman = tool.holder?.kind === "craftsman";
    const submit = async () => {
        const empty = !sigRef.current || sigRef.current.isEmpty();
        if (craftsman && empty) { toast.error("Vrácení od řemeslníka je potřeba podepsat"); return; }
        setBusy(true);
        try {
            const r = await api.post(`/tools/${tool.id}/return`, { condition, signature_data_url: empty ? null : sigRef.current.toDataURL() });
            toast.success(r.data.protocol ? `Nářadí vráceno · protokol ${r.data.protocol.number} uložen` : "Nářadí vráceno"); onDone();
        } catch (e) { toast.error(e.response?.data?.detail || "Vrácení selhalo"); }
        finally { setBusy(false); }
    };
    return (
        <Modal title={`Vrátit – ${tool.name}`} onClose={onClose} testid="return-modal" footer={<><button onClick={onClose} className={modalBtnSecondary}>Zrušit</button><button onClick={submit} disabled={busy} data-testid="return-submit" className={modalBtnPrimary}>Vrátit</button></>}>
            <div className="space-y-3">
                <div className="text-sm text-slate-700">Vrací: <b>{tool.holder?.name}</b>{tool.holder?.job_title ? ` · ${tool.holder.job_title}` : ""}</div>
                <div><label className="label-eyebrow block mb-1.5">Stav při vrácení / poškození</label><textarea rows={2} value={condition} onChange={(e) => setCondition(e.target.value)} data-testid="return-condition" className={inp} placeholder="např. v pořádku, kompletní / chybí kotouč, prasklý kryt" /></div>
                <div>
                    <label className="label-eyebrow block mb-1.5 inline-flex items-center gap-1.5"><PenLine className="w-3.5 h-3.5" /> Podpis přebírajícího zpět {craftsman ? "(povinný)" : "(volitelný)"}</label>
                    <SignaturePad ref={sigRef} height={170} testid="return-signature" />
                </div>
            </div>
        </Modal>
    );
}
